// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__pEhgW","wrapItem":"styles_wrapItem__oLSb7","onboardingImg":"styles_onboardingImg__hgck1","loading":"styles_loading__EYEEf"};